import { render, staticRenderFns } from "./CashCards.vue?vue&type=template&id=4f56d8bb&scoped=true&"
import script from "./CashCards.vue?vue&type=script&lang=js&"
export * from "./CashCards.vue?vue&type=script&lang=js&"
import style0 from "./CashCards.vue?vue&type=style&index=0&id=4f56d8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56d8bb",
  null
  
)

export default component.exports